export enum AssistPanelContentType {
  SubscriptionButton = "subscription_button",
}

export enum AssistPanelItemId {
  Subscription = "assist_panel_subscription",
}

export type AssistPanelEvent =
  | {
      // Assistパネルが開かれたか
      event: "assist_panel";
      action: "open" | "close";
    }
  | {
      // Assist実行のコンバージョンイベント
      event: "assist_request";
      action: "submit";
      writerType: string;
      manuscriptCount?: number;
      totalCharacters?: number;
      novelId?: string;
      requestType?: string;
    }
  | {
      // ボタン等が押されたか
      event: "select_content";
      contentType: AssistPanelContentType | string;
      itemId: AssistPanelItemId | string;
      contentId?: string;
    };
